import ImageSwiper3 from '../ImageSwiper3'

export function Hero() {
  return (
    <div className='welcomeTheme3-hero' id='home'>
      <ImageSwiper3 />
    </div>
  )
}
